// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hi-0";
export var actionModalContentContainer = "_hi-1";
export var createTagButton = "_hi-2";
export var footerContainer = "_hi-7";
export var fullWidthDivider = "_hi-3";
export var hasCreateTagButton = "_hi-4";
export var noCreateTagButton = "_hi-5";
export var tagsContainer = "_hi-6";
export var tagsModalContentContainer = "_hi-8";